<template>
  <vx-card no-shadow>
    <!-- Img Row -->
    <!-- <div class="flex flex-wrap items-center mb-base">
      <vs-avatar :src="data.foto" size="70px" class="mr-4 mb-4" />
      <div>
        <vs-button class="mr-4 sm:mb-0 mb-2">Anexar foto</vs-button>
        <vs-button type="border">Remover</vs-button>
      </div>
    </div> -->

    <!-- Info -->
    <vs-input
      class="w-1/4 mb-4"
      label="Nome completo"
      v-model="data.nome"
    ></vs-input>

    <vs-input
      disabled
      class="w-1/4 mb-4"
      label="Email"
      v-model="data.email"
    ></vs-input>
    <vs-input
      class="w-1/4 mb-4"
      label="Telefone"
      v-model="data.telefone"
    ></vs-input>
    <vs-input class="w-1/4 mb-4" label="CPF" v-model="data.cpf"></vs-input>
    <vs-input
      class="w-1/4 mb-4"
      label="RG/RNM"
      v-model="data.documento"
    ></vs-input>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="saveData"
        >Salvar Alterações</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
export default {
  methods: {
    async saveData() {
      this.$emit("done");
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      item: {},
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
};
</script>
